export default function (array){
  var out = {
    x: array[0],
    y: array[1]
  };
  if (array.length>2) {
    out.z = array[2];
  }
  if (array.length>3) {
    out.m = array[3];
  }
  return out;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/common/toPoint.js
// module id = 30
// module chunks = 4